import React from 'react';
import Page from "../../containers/Page/Page";
import { Button, Box, Typography, TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Grid, Chip } from "@material-ui/core";
import { Pagination } from '@material-ui/lab';
import SearchField from "../../components/SearchField";
import { useHistory } from "react-router-dom";
import { api } from '../../services/api';
import moment from 'moment';
import { Helpers } from '../../utils/Helpers';
import { usePermissions } from '../../hooks/permissions';

interface IData {
    data: {
        id: string;
        codigo_sap: string;
        nome: string;
        bomba: string;
        ativa: boolean;
        created_at: string;
    }[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

function Acessorios() {

    const history = useHistory();
    const permissions = usePermissions();
    const query = new URLSearchParams(history.location.search);

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [search, setSearch] = React.useState<string>(query.get('search') || '');
    const [data, setData] = React.useState<IData>();

    /**
     * Ao carregar a página.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar acessórios.
     * @param page 
     */
    async function handleFetch(page: number = Number(query.get('page')) || 1) {
        setLoading(true);
        try {
            const url = `/acessorios?search=${search}&page=${page}`;
            const response = await api.get(url);
            history.push(url);
            setData(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    /**
     * Pesquisar com ENTER.
     * @param event 
     */
    function handleSearchKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (event.key === 'Enter') {
            handleFetch(1);
        }
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Acessórios
                </Typography>
                {permissions.has('acessorio.show') &&
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => history.push('/acessorios/create')}>
                        Novo Acessório
                    </Button>
                }
            </Page.Title>
            {data &&
                <Page.Section>
                    <Page.Toolbar>
                        <SearchField
                            placeholder="Pesquisa"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            onClick={() => handleFetch(1)}
                            onKeyUp={(event) => handleSearchKeyUp(event)}
                        />
                    </Page.Toolbar>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Código SAP</TableCell>
                                        <TableCell>Acessório</TableCell>
                                        <TableCell>Bomba</TableCell>
                                        <TableCell>Ativo</TableCell>
                                        <TableCell>Data Criação</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.data.map((acessorio) => (
                                        <TableRow
                                            key={acessorio.id}
                                            hover={true}
                                            onClick={() => history.push(`/acessorios/${acessorio.id}`)}
                                        >
                                            <TableCell>{acessorio.id}</TableCell>
                                            <TableCell>{acessorio.codigo_sap}</TableCell>
                                            <TableCell>{acessorio.nome}</TableCell>
                                            <TableCell><Chip label={acessorio.bomba} /></TableCell>
                                            <TableCell>{acessorio.ativa ? 'Sim' : 'Não'}</TableCell>
                                            <TableCell>{moment(acessorio.created_at).format('DD/MM/YYYY')}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box p={2}>
                            <Grid container justifyContent="center">
                                <Pagination
                                    page={data.current_page}
                                    count={data.last_page}
                                    onChange={(_event, page) => handleFetch(page)}
                                    color="secondary"
                                />
                            </Grid>
                        </Box>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default Acessorios;